import { makeAutoObservable } from "mobx";
import {
  CertificationOut,
  EPDConformityOut,
  getLocalAuthHeader,
  inventoryEPDsApi,
} from "../api-client";

export class ConformityStore {
  certificationOptions: CertificationOut[] = [];
  conformityOptions: EPDConformityOut[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  static instance: ConformityStore;

  setCertificationOptions(certificationOptions: CertificationOut[]) {
    this.certificationOptions = certificationOptions;
  }

  setConformityOptions(conformityOptions: EPDConformityOut[]) {
    this.conformityOptions = conformityOptions;
  }

  async fetchCertificationData() {
    if (this.certificationOptions.length) return;
    const authHeader = getLocalAuthHeader();
    return await inventoryEPDsApi()
      .inventoryApiV1RoutersEpdCertificationData(authHeader)
      .then((response) => {
        this.setCertificationOptions(response.data);
        return response.data;
      })
      .catch((error) =>
        console.error("Failed to fetchCertificationData:", error)
      );
  }

  async fetchConformities() {
    if (this.conformityOptions.length) return;
    const authHeader = getLocalAuthHeader();
    await inventoryEPDsApi()
      .inventoryApiV1RoutersEpdEpdConformityData(authHeader)
      .then((response) => this.setConformityOptions(response.data))
      .catch((error) => console.error("getConformities.error", error));
  }

  static getInstance(): ConformityStore {
    if (!ConformityStore.instance) {
      ConformityStore.instance = new ConformityStore();
    }
    return ConformityStore.instance;
  }
}

export const conformityStore = ConformityStore.getInstance();
